import * as yup from "yup";

export default yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  company_name: yup.string().notRequired(),
  phone: yup.string().notRequired(),
  subject: yup.string().notRequired(),
  message: yup.string().min(20).required(),
  "g-recaptcha-response": yup
    .string()
    .nullable(true)
    .required("You must check the reCAPTCHA."),
});
